import React from 'react'
import SolutionBaseReport from '../comp_reusable/solution_reports/SolutionBaseReport'
import injectionConfig from './injectionConfig.json'
import { CUSTOM_COMPONENT_REGISTRY } from './CustomComponentRegistry'
import { useOptimizeReportStore } from './stores/optimizeReportStore'

const ModelResult: React.FC = () => {
  return (
    <SolutionBaseReport
      injectionConfig={injectionConfig}
      componentRegistry={CUSTOM_COMPONENT_REGISTRY}
      store={useOptimizeReportStore}
      reportTitle="Optimize model report"
    />
  )
}

export default ModelResult
